import React from 'react';
import { TrendingUp, AlertTriangle, Users, Package, FileText, Quote } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const metricCards = [
  { id: 'metric-today-sales', label: "Today\'s Sales", icon: TrendingUp, hero: true, color: 'bg-gradient-primary text-white', iconBg: 'bg-white/20' },
  { id: 'metric-monthly-sales', label: 'Monthly Sales', icon: TrendingUp, color: 'bg-card', iconBg: 'bg-positive/10', iconColor: 'text-positive' },
  { id: 'metric-pending', label: 'Pending Payments', icon: AlertTriangle, color: 'bg-card border-warning/30', iconBg: 'bg-warning/10', iconColor: 'text-warning', alert: true },
  { id: 'metric-customers', label: 'Total Customers', icon: Users, color: 'bg-card', iconBg: 'bg-primary/10', iconColor: 'text-primary' },
  { id: 'metric-products', label: 'Products', icon: Package, color: 'bg-card', iconBg: 'bg-accent/10', iconColor: 'text-accent' },
  { id: 'metric-invoices', label: 'Total Invoices', icon: FileText, color: 'bg-card', iconBg: 'bg-primary/10', iconColor: 'text-primary' },
  { id: 'metric-quotations', label: 'Quotations', icon: Quote, color: 'bg-card', iconBg: 'bg-positive/10', iconColor: 'text-positive' },
];

export default function DashboardBentoGrid() {
  const hero = metricCards?.[0];
  const rest = metricCards?.slice(1);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
      {/* Hero card — spans 2 cols */}
      <div className={`col-span-1 sm:col-span-2 rounded-2xl p-6 card-shadow-lg ${hero?.color} relative overflow-hidden`}>
        <div className="absolute top-0 right-0 w-40 h-40 rounded-full bg-white/10 -translate-y-10 translate-x-10" />
        <div className="absolute bottom-0 left-0 w-28 h-28 rounded-full bg-white/5 translate-y-10 -translate-x-6" />
        <div className="relative z-10">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-sm font-500 text-white/70 uppercase tracking-wider">{hero?.label}</p>
              <p className="text-5xl font-800 text-white mt-2 font-tabular">—</p>
            </div>
            <div className={`w-12 h-12 rounded-xl ${hero?.iconBg} flex items-center justify-center`}>
              <hero.icon size={22} className="text-white" />
            </div>
          </div>
          <div className="flex items-center gap-2 mt-4">
            <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/20 text-white text-xs font-600">
              No data yet
            </span>
          </div>
        </div>
      </div>
      {/* Rest of metrics */}
      {rest?.map((m) => {
        const Icon = m?.icon;
        return (
          <div
            key={m?.id}
            className={`rounded-2xl p-5 border border-border card-shadow ${m?.color} ${m?.alert ? 'border-warning/40' : ''} relative group`}
          >
            {m?.alert && (
              <div className="absolute top-3 right-3 w-2 h-2 rounded-full bg-warning" />
            )}
            <div className="flex items-start justify-between mb-3">
              <div className={`w-10 h-10 rounded-xl ${m?.iconBg} flex items-center justify-center`}>
                <Icon size={18} className={m?.iconColor || 'text-foreground'} />
              </div>
            </div>
            <p className="text-2xs font-500 uppercase tracking-wider text-muted-foreground">{m?.label}</p>
            <p className="text-4xl font-800 text-foreground mt-1 font-tabular">—</p>
            <p className="text-xs text-muted-foreground mt-2">No data yet</p>
          </div>
        );
      })}
    </div>
  );
}